import { Injectable } from '@angular/core';
import { Themes } from '../models/themes.model';
import {  HttpClient } from '@angular/common/http';
import   'rxjs/add/operator/map';
import { SistemaService } from '../services/sistema/sistema.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemesService {

  url:string;
  themes:Themes[] = [];
  themesC:Themes[] = [];

  constructor( private http:HttpClient, private _sistemaService:SistemaService) {
    this.url = _sistemaService.url;
  }

  getThemes(): Observable<Themes[]>{
    return this.http.get(`${this.url}/themes/`).map(this.extractThemes);
  }

  extractThemes(res:any) {
    this.themes = [];
    for (let i = 0; i < res.length; i++) {
      let tmp:Themes = {
        _id:res[i]._id,
        name:res[i].name,
        hashtag:res[i].hashtag,
        lemaxId:res[i].lemaxId,
        seoDescription:res[i].seoDescription,
        seoKeywords:res[i].seoKeywords,
        shortDescription:res[i].shortDescription,
        tripInfo:res[i].tripInfo,
        themeCategoryName:[]
      }
      this.themes.push(tmp);
    }
    // console.log("themes ----> ",this.themes);
    return this.themes;
  }


}
